import Icon from "@ant-design/icons";
import { CustomIconComponentProps } from "@ant-design/icons/es/components/Icon";

export default function WaterIcon(props: Partial<CustomIconComponentProps>) {
  return (
    <Icon
      {...props}
      component={() => (
        <svg
          width={props.width || 24}
          height={props.height || 24}
          viewBox="0 0 12 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.36947 3.48112C7.98695 4.77553 8.96313 6.09504 9.96468 7.65918C10.4382 8.39864 10.9059 9.18164 11.2562 9.96305C11.6025 10.7357 11.8804 11.6063 11.8804 12.507C11.8803 15.7458 9.25492 18.3712 6.01611 18.3713C2.78637 18.3713 0.151888 15.7956 0.151855 12.507C0.151855 11.6011 0.425989 10.726 0.771973 9.94596C1.12136 9.15825 1.58792 8.37201 2.06185 7.6307C3.06631 6.05954 4.04016 4.7552 4.66846 3.46891L6.03158 0.676758L7.36947 3.48112ZM6.01611 4.12728C4.66025 6.90309 1.65169 10.0559 1.65169 12.507C1.65172 14.958 3.60567 16.8714 6.01611 16.8714C8.4265 16.8713 10.3805 14.9174 10.3805 12.507C10.3805 10.0965 7.35803 6.94024 6.01611 4.12728Z"
            fill="#1890FF"
          />
        </svg>
      )}
    />
  );
}
